import { IS_DEMO, JARVIS_URL, LOCAL_STORAGE_WORKSPACE_ID } from './constants';

const isDemo = IS_DEMO;
const MIDDLEWARE_URL = import.meta.env.VITE_API_URL_MIDDLEWARE;

//Use middleware on development for jarvis routes
const JARVIS = !isDemo ? `${MIDDLEWARE_URL}/api/jarvis/shapi` : JARVIS_URL;

//Use middleware on development for lighthouse routes
const VITE_API_URL = !isDemo
  ? `${MIDDLEWARE_URL}/api/lighthouse/shapi`
  : import.meta.env.VITE_API_URL;

//Use middleware on development for file manager routes
const VITE_API_URL_FILE_MANAGER = !isDemo
  ? `${MIDDLEWARE_URL}/api/filemanager`
  : import.meta.env.VITE_API_URL_FILE_MANAGER;

const VITE_LANGFLOW_HOST_URL = import.meta.env.VITE_LANGFLOW_HOST_URL;
const VITE_LANGFLOW_FLOW_ID = import.meta.env.VITE_LANGFLOW_FLOW_ID;
export const ASSET_ENDPOINT = `${VITE_API_URL}/asset`;
export const ASSET_V2_ENDPOINT = `${VITE_API_URL}/v2/asset`;
export const ASSET_V3_ENDPOINT = `${VITE_API_URL}/v3/assets`;
export const MODEL_V2_ENDPOINT = `${VITE_API_URL}/v2/models`;
export const MODEL_V3_ENDPOINT = `${VITE_API_URL}/v3/models`;
export const CASES_ENDPOINT = `${VITE_API_URL}/v2/cases`;
export const WORKSPACE_V2_ENDPOINT = `${VITE_API_URL}/v2/workspaces`;
export const EVENT_V2_ENDPOINT = `${VITE_API_URL}/v2/events`;
export const CONDITION_DEVIATION = `${VITE_API_URL}/v2/condition_deviations`;
export const REPORTS = `${VITE_API_URL}/v2/reports`;
export const OIL_SYSTEM = `${VITE_API_URL}/v2/oil_system`;
export const FLARE_ENDPOINT = `${VITE_API_URL}/v2/flare`;
export const MODEL_ENDPOINT = `${VITE_API_URL}/v2/models`;

export const ASSET_SUMMARY = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/summary`;

export const ATTRIBUTES_BY_ID = (assetId?: number | string) => {
  return `${ASSET_V2_ENDPOINT}s/${assetId}/properties`;
};

export const WORKSPACES = `${JARVIS}/workspaces`;
export const PERMISSIONS = `${VITE_API_URL}/v2/users/me/permissions`;
export const DOMAIN_HINT = `${JARVIS}/iam/identity/domain/hint`;

export const ASSET_TREE_BY_WORKSPACE = (WORKSPACE_ID?: string) =>
  `${JARVIS}/workspaces/${WORKSPACE_ID}/items/tree`;

export const ASSET_SUMMARY_RERT_BY_ASSET = (
  assetId?: string,
  month?: number | string,
  year?: number | string,
) => `${ASSET_V2_ENDPOINT}s/${assetId}/summary/condition-deviation/${month}/${year}`;

export const OVERVIEW_SUMMARY = (workspaceId?: string) =>
  `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/health/summary`;
export const OVERVIEW_ASSETS = (asset_id?: string) => `${ASSET_V2_ENDPOINT}s/${asset_id}/health`;

export const ASSETS_WITH_HEALTH_BY_ID = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/rert`;

export const ASSET_MODELS = (assetId?: number | string) => `${ASSET_ENDPOINT}/${assetId}/model`;

export const ASSET_EXTERNAL_VIBRATION_ANALYSIS = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/external/vibration/analysis`;

export const ASSET_EXTERNAL_OIL_ANALYSIS = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/external/oil/analysis`;
export const ASSET_EXTERNAL_SAP_NOTIFICATIONS = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/external/sap/notification`;

export const ASSET_EXTERNAL_MAINTENANCE_PLAN = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/external/sap/maintenance/items`;

export const SENSORS = (assetId?: number | string) => `${ASSET_V2_ENDPOINT}s/${assetId}/sensors`;
export const SENSORS_DATA = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/sensors/values`;

export const SENSORS_DATA_BY_MODEL = (modelName?: string) =>
  `${MODEL_ENDPOINT}/${modelName}/sensors/value`;

export const SENSORS_STATUS_SUMMARY = (assetId?: number | string) =>
  `${ASSET_ENDPOINT}/${assetId}/sensor/status/summary`;
export const SENSORS_STATUS_BY_CHILD = (assetId?: number | string | null) =>
  assetId
    ? `${ASSET_ENDPOINT}/${assetId}/sensor/status/by-child`
    : `${ASSET_ENDPOINT}/sensor/status/by-child/root`;

export const SENSORS_LIST_BY_ASSET_ID = (assetId?: string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/sensors/values/latest`;

export const SENSORS_BY_MODEL_NAME = (modelName?: string) =>
  `${VITE_API_URL}/v2/models/${modelName}/sensors/reference`;

export const SENSORS_BY_EVENT_ID = (eventId?: string) =>
  `${VITE_API_URL}/v2/events/${eventId}/sensors`;

export const SENSORS_GRAPH = (assetId?: string) =>
  `${VITE_API_URL}/v2/assets/${assetId}/sensors/values`;

export const ALL_SENSORS_BY_ID = (assetId: string) =>
  `${VITE_API_URL}/v2/assets/${assetId}/properties`;

export const SENSORS_BY_STATUS_NAME = (assetId: string) =>
  `${VITE_API_URL}/v2/assets/${assetId}/properties/sensors`;

export const GET_ALL_AVAILABLE_GRAPHS_BY_EVENT_ID = (eventId?: string) =>
  `${VITE_API_URL}/v2/events/${eventId}/plots`;

export const AUDIT_ENDPOINT = `${VITE_API_URL}/audit`;
export const AUDIT_ENDPOINT_TAG_HISTORY = (tagId: number) =>
  `${AUDIT_ENDPOINT}?primary_key=${tagId}&audit_type=tag`;

export const FILEMANAGER_ENDPOINT_FILE = `${VITE_API_URL_FILE_MANAGER}/file`;
export const FILEMANAGER_ENDPOINT_LIST = `${VITE_API_URL_FILE_MANAGER}/file/list`;
export const FILEMANAGER_BATCH_DOWNLOAD = `${FILEMANAGER_ENDPOINT_FILE}/batch/download`;
export const FILEMANAGER_BATCH_LIST = `${FILEMANAGER_ENDPOINT_FILE}/batch/list`;

export const TAG_BY_ID = (assetId?: number | string, tagId?: number | string) =>
  `${ASSET_ENDPOINT}/${assetId}/tag/${tagId}`;

export const TAG_LIST = (assetId?: number | string) => `${ASSET_ENDPOINT}/${assetId}/tag`;

export const TAG_COUNT_BY_CHILD = (assetId?: number | string) =>
  `${ASSET_ENDPOINT}/${assetId}/tag/count/by-child`;
export const TAG_ROOT_COUNT_BY_CHILD = `${ASSET_ENDPOINT}/tag/count/by-child/root`;

export const FEATURES_BY_MODEL = (modelName?: number | string) =>
  `${VITE_API_URL}/v2/models/${modelName}/features/reference`;

export const FEATURES_MODEL_GRAPH = (modelName?: string) =>
  `${VITE_API_URL}/v2/models/${modelName}/plots/features`;
export const FEATURES_ASSET_GRAPH = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/features/values`;
export const FEATURES_BY_ASSET_ID = (assetId?: string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/calculated-variables/last`;

export const FEATURE_CONTRIBUTION = (assetId?: number | string) =>
  `${ASSET_ENDPOINT}/${assetId}/feature/contribution`;
export const FEATURE_BY_MODEL_ENDPOINT = `${ASSET_ENDPOINT}/feature/values`;

export const CATEGORIES_LIST = `${ASSET_ENDPOINT}/category/list`;

export const CSV = `${ASSET_ENDPOINT}/csv`;

export const CSV_TEMPLATE = (templateName: string) => `${CSV}/template/${templateName}`;

export const CATEGORY_BY_ID = (assetId?: number | string) =>
  `${ASSET_ENDPOINT}/${assetId}/category`;

export const ATTRIBUTE_BY_ID = (assetId?: number | string) =>
  `${ASSET_ENDPOINT}/${assetId}/attribute`;

export const VET_CURRENT_CAMPAIGN = `${VITE_API_URL}/vet/current_campaign`;
export const VET_CIP_CHART = (assetId?: number | string) =>
  `${VITE_API_URL}/vet/${assetId}/get_cip_chart`;
export const VET_CIP_VALUES = (assetId?: number | string) =>
  `${VITE_API_URL}/vet/${assetId}/get_cip_values`;

// MODELS

export const MODEL = (assetId?: number | string, modelName?: string) =>
  `${ASSET_ENDPOINT}/${assetId}/model/${modelName}`;
export const MODELS_SUMMARY_BY_ASSET_MONITORING = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/models`;
export const RELATED_MODELS_SCALING = (model_name?: string) =>
  `${VITE_API_URL}/v2/models/${model_name}/related`;

export const RISK_MODEL_BY_ASSET = (assetId?: number | string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/probability-models`;
export const USER_MODEL = (assetId?: number | string) => `${ASSET_ENDPOINT}/${assetId}/user-model`;
export const USER_MODEL_ON_OFF = (assetId?: number | string) =>
  `${ASSET_ENDPOINT}/${assetId}/user-model/on-off`;

export const ALARM_HISTORY = (model_name: string) => `${MODEL_ENDPOINT}/${model_name}/events`;
export const MODELS_BY_ASSET = (assetId?: number | string) =>
  `${ASSET_V3_ENDPOINT}/${assetId}/models`;

// PREDICTION
export const PREDICTION_DATA = (assetId?: number | string) =>
  `${ASSET_ENDPOINT}/${assetId}/prediction`;
export const PREDICTION_TIMELINE = (assetId?: number | string) =>
  `${ASSET_ENDPOINT}/${assetId}/prediction/timeline`;
export const PUMP_CURVE_DATA = (assetId?: number | string) =>
  `${PREDICTION_DATA(assetId)}/pump-curve`;
export const RISK_SCORE_CHART = (modelName: string) =>
  `${VITE_API_URL}/v2/models/${modelName}/plots/risk`;

// EVENT ENDPOINTS
export const EVENT_ENDPOINT = `${VITE_API_URL}/event`;
export const EVENT_LIST = `${EVENT_ENDPOINT}/all`;
export const EVENTS_AUTOMATIC_ACK_INFO = (
  workspaceId: string,
) => `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/events/acknowledge/summary
`;
export const EVENTS_AUTOMATIC_ACK_MODELS = `${MODEL_V3_ENDPOINT}/auto-acknowledges/summary
`;

export const EVENT_BY_ID = (eventId?: string | number) => `${EVENT_V2_ENDPOINT}/${eventId}`;
export const REASONS_BY_EVENT_ID = (eventId?: string | number) =>
  `${EVENT_V2_ENDPOINT}/${eventId}/options`;
export const EVENT_COUNT = (assetId?: string | number) =>
  `${ASSET_ENDPOINT}/${assetId}/event/count/by-child`;
export const EVENT_COUNT_ROOT = `${ASSET_ENDPOINT}/event/count/by-child/root`;
export const EVENT_SIMILAR = (assetId?: string | number, eventId?: string) =>
  `${ASSET_V2_ENDPOINT}s/${assetId}/events/${eventId}/similar`;

export const EVENT_FILTER_OPTIONS = (assetId?: string | number) =>
  `${WORKSPACE_V2_ENDPOINT}/${assetId}/events/filters/options`;

export const EVENT_PI_URL = (id: string | number) => `${JARVIS}/items/${id}/attributes`;

// EVENT ANALYSIS
export const EVENT_ANALYSIS = (eventId: string | number) => `${EVENT_ENDPOINT}/${eventId}/analysis`;
export const EVENT_FLOW_OPTIONS = `${EVENT_ENDPOINT}/analysis/flow-options`;

// EVENT COMMENT
export const EVENT_COMMENT = (eventId?: string | number) => `${EVENT_ENDPOINT}/${eventId}/comment`;

export const RADAR_PLOT_VIEW = (model_name?: string) => `
${MODEL_V2_ENDPOINT}/${model_name}/plots/radar`;

export const AMOEBA_PLOT_VIEW = (model_name?: string) => ` 
${MODEL_V2_ENDPOINT}/${model_name}/plots/amoeba`;

export const RISK_PLOT_VIEW = (model_name?: string) => `
${MODEL_V2_ENDPOINT}/${model_name}/plots/risk`;

export const EVENTS = (workspaceId?: number | string) => {
  return `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/events`;
};

export const AGGREGATED_ALARMS = (alarmId?: number | string) => {
  return `${EVENT_V2_ENDPOINT}/${alarmId}/alarms`;
};

export const UPDATE_EVENT = (eventId?: number | string) => {
  return `${EVENT_V2_ENDPOINT}/${eventId}`;
};
export const UPDATE_EVENTS = `${EVENT_V2_ENDPOINT}/batch`;

// CASES
export const CASES_BY_ID = (CASE_ID?: string) => {
  return `${CASES_ENDPOINT}/${CASE_ID}`;
};

export const WORKSPACES_CASES = () => {
  const workspaceId = localStorage.getItem(LOCAL_STORAGE_WORKSPACE_ID) as string;
  return `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/cases`;
};

export const CASES = (eventId?: string) => `${WORKSPACES_CASES()}/${eventId}`;
export const CASES_FILTERS_OPTIONS = () => `${WORKSPACES_CASES()}/filters/options`;
export const CASES_OPTIONS = () => `${WORKSPACES_CASES()}/options`;
export const CASES_OWNERS = `${VITE_API_URL}/v2/cases/owners`;

export const CASES_DIAGNOSIS = (eventId?: string) => `${CASES(eventId)}/diagnosis`;
export const CASES_ACTIONS = (eventId?: string) => `${CASES(eventId)}/actions`;
export const CASES_FEEDBACK = (eventId?: string) => `${CASES(eventId)}/feedback`;
export const CASES_ALARMS = (eventId?: string) => `${CASES(eventId)}/alarms`;

export const TEMPLATE_OPTIONS = (name: string) => {
  const workspaceId = localStorage.getItem(LOCAL_STORAGE_WORKSPACE_ID) as string;
  return `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/template/${name}/options`;
};

// CONDITION DEVIATION
export const CONDITION_DEVIATION_CATEGORIES_OPTIONS = (WORKSPACE_ID?: string) => `
${WORKSPACE_V2_ENDPOINT}/${WORKSPACE_ID}/condition_deviation/filters/options`;

export const CONDITION_DEVIATION_OPTIONS = (WORKSPACE_ID?: string) =>
  `${WORKSPACE_V2_ENDPOINT}/${WORKSPACE_ID}/condition_deviations/options`;

export const CONDITION_DEVIATION_EQUIPMENTS = (WORKSPACE_ID?: string) =>
  `${WORKSPACE_V2_ENDPOINT}/${WORKSPACE_ID}/assets`;

export const CREATE_CONDITION_DEVIATION = `${CONDITION_DEVIATION}`;

export const EDIT_CONDITION_DEVIATION = (condition_deviation_id: string) =>
  `${CONDITION_DEVIATION}/${condition_deviation_id}`;

export const CONDITION_DEVIATION_LIST = (WORKSPACE_ID?: string) => {
  return `${WORKSPACE_V2_ENDPOINT}/${WORKSPACE_ID}/condition_deviations`;
};
export const CONDITION_DEVIATION_BY_ASSET_ID = (asset_id: string) => {
  return `${ASSET_V2_ENDPOINT}s/${asset_id}/condition-deviations`;
};
export const CONDITION_DEVIATION_BY_ID = (condition_deviation_id?: string) => {
  return `${CONDITION_DEVIATION}/${condition_deviation_id}`;
};
// REPORTS
export const HEALTH_TREE = (month: string | number, year: string | number) =>
  `${ASSET_V2_ENDPOINT}s/health_score/${month}/${year}`;

export const REPORTS_ASSETS_HEALTH = (
  asset_id?: string,
  month?: string | number,
  year?: string | number,
) => `${REPORTS}/${asset_id}/rert/${month}/${year}`;

export const REPORTS_PDF = (
  asset_id?: string,
  month?: string | number,
  year?: string | number,
  workspaceId?: string,
) => {
  return `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/reports/${month}/${year}/${asset_id}`;
};
// Flare
export const FLARE_LIST = (vesselId?: string) => {
  return `${FLARE_ENDPOINT}/${vesselId}/events`;
};
export const FLARE_VESSEL_CHART = (vesselId?: string) => {
  return `${FLARE_ENDPOINT}/${vesselId}/data_point`;
};
export const FLARE_SUBCATEGORY = (vesselId?: string) => {
  return `${FLARE_ENDPOINT}/${vesselId}/events_subcategory`;
};

export const UPDATE_COMMENT = (eventId: string) => {
  return `${VITE_API_URL}/v2/events/${eventId}`;
};

export const FLARE_TOTAL_VOLUME = (vesselId?: string) => {
  return `${FLARE_ENDPOINT}/${vesselId}/total_volume`;
};

export const FLARE_CSV = (vesselId?: string) => {
  return `${FLARE_ENDPOINT}/${vesselId}/export_events`;
};
// NOTIFICATIONS
export const NOTIFICATIONS_LIST = `${VITE_API_URL}/v3/users/me/notifications`;
export const NOTIFICATIONS_CREATE = `${VITE_API_URL}/v3/users/me/notifications`;
export const NOTIFICATION_DELETE = (notification_id: string) =>
  `${VITE_API_URL}/v3/users/me/notifications/${notification_id}`;
export const NOTIFICATION_UPDATE = (notification_id: string) =>
  `${VITE_API_URL}/v3/users/me/notifications/${notification_id}`;
// PERFORMANCE
export const PERFORMANCE_FILTER_OPTIONS = (workspaceId: string) =>
  `${VITE_API_URL}/v2/oil_system/workspaces/${workspaceId}/filters/options`;

export const CHATBOT_PROMPT_ENDPOINT = (workspaceId: string) => {
  const flowId = 'main-lighthouse-assistant';
  if (IS_DEMO) {
    return `${VITE_LANGFLOW_HOST_URL}/api/v1/run/${VITE_LANGFLOW_FLOW_ID}?stream=false`;
  }

  return `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/chatbot/${flowId}`;
};
export const CHATBOT_RETRIEVE_SESSION_ENDPOINT = (workspaceId: string, sessionId: string) => {
  if (IS_DEMO) {
    const params = new URLSearchParams({
      flow_id: VITE_LANGFLOW_FLOW_ID,
      session_id: sessionId,
      order_by: 'timestamp',
    });
    return `${VITE_LANGFLOW_HOST_URL}/api/v1/monitor/messages?${params.toString()}`;
  }
  const params = new URLSearchParams({
    session_id: sessionId,
  });
  return `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/chatbot/history?${params.toString()}`;
};

export const CHATBOT_GET_TRACE_ID = (sessionId: string, workspaceId: string) =>
  `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/chatbot/${sessionId}/traces`;

export const CHATBOT_ADD_FEEDBACK = (traceId: string, workspaceId: string) =>
  `${WORKSPACE_V2_ENDPOINT}/${workspaceId}/chatbot/messages/${traceId}/score`;
